<template>
  <div>
    <drawer-sub />
    <google-map :style="{ width: 'auto', height: height + 'px' }" :zoomLevel="getZoomLevel" />
    <div v-if="!reservationMode" class="absolute inline-block -mt-6 w-full h-10 text-center">
      <a @click="openPlaceList" class="inline-flex justify-center items-center px-4 h-6 bg-white rounded-t text-link shadow-sm">{{ $t('tour_search_place') }}</a>
    </div>
    <drawer />
    <reservation-modal
      v-if="reservationMode"
      v-show="modal.show"
      :closeModal="() => closeModal()"
      :modals=modals
      :kind=modal.kind
      :target=modal.target />
    <location-button @getLocation="onGetLocation" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GoogleMap from './GoogleMap'
import LocationButton from '../../molecules/LocationButton'
import Drawer from './Drawer'
import DrawerSub from './DrawerSub'
import ReservationModal from "@/components/molecules/ReservationModal"
import ReservationError from "@/components/molecules/ReservationError"

export default {
  components: {
    GoogleMap,
    LocationButton,
    Drawer,
    DrawerSub,
    ReservationModal
  },
  props:{
    zoomLevel: {
      type: Number,
      required:false,
      default: 15
    }
  },
  data () {
    return {
      modal: {
        show: false,
        kind: 'error',
        target: undefined
      },
      windowHeight: window.innerHeight
    }
  },
  mounted () {
    window.addEventListener('resize', ()=>{
      this.windowHeight = window.innerHeight
    })
  },
  methods: {
    onGetLocation: function (location) {
      this.$store.dispatch('map/updateCenter', location)
    },
    openPlaceList: function () {
      this.$store.dispatch('map/recommendSearchCourse')
      this.$store.dispatch('drawer/open', { component: 'PlaceList' })
    },
    closeModal: function () {
      this.modal.show = false
      this.$store.dispatch('reservation/handleErrorOff')
    },
    showModal: function () {
      this.modal.show = true
    }
  },
  computed: {
    ...mapGetters({
      center: 'map/getCenter',
      reservationMode: 'reservation/getMode',
      showErrorModal: 'reservation/getShowErrorModal'
    }),
    height: function () {
      const isOpen = this.$store.getters['drawer/getIsOpen']
      const isFull = this.$store.getters['drawer/getIsFull']
      // header: 48, foot: 45
      const h = isOpen && isFull ? 300 : 48 + 45
      const i = this.windowHeight - h

      this.$store.dispatch('map/updateHeight', i)

      return i
    },
    modals: function () {
      return {
        'error' : {
          callback: () => null,
          component: ReservationError
        }
      }
    },
    getZoomLevel() {
      return this.zoomLevel;
    }
  },
  watch: {
    center: function () {
      this.showPlaceList = false
    },
    showErrorModal: function (val) {
      if (val) {
        this.showModal()
      }
    }
  }
}
</script>
